import { z } from 'zod'

import { columnsSchema } from '@/utils/zod'

export const groupGradesFilters = z.object({
  semesterId: z.string(),
  courseId: z.string().optional(),
  groupId: z.string().optional(),
  ...columnsSchema.shape
})
